import React from 'react';
import { useMatchMakingStore } from './store';
import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import WhiteCard from './WhiteCard';

const ReportList = ({ onDownloadCsv, onGenerateCsv }) => {
  const intl = useIntl();
  const i18n = translations.MatchMakingV2(intl).REPORTS;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [reports, generateCsvBtn, downloadCsvBtn, updateCsvBtn] =
    useMatchMakingStore((state) => [
      state.reports,
      state.generateCsvBtn,
      state.downloadCsvBtn,
      state.updateCsvBtn,
    ]);

  return (
    <>
      <Stack
        flexDirection={isSmDown ? 'column' : 'row'}
        alignItems={isSmDown ? 'flex-start' : 'center'}
        justifyContent={'space-between'}
        gap={'20px'}
      >
        <Stack gap={'5px'}>
          <Typography variant="body2" textAlign={'start'}>
            {i18n.noReportsTitle}
          </Typography>
        </Stack>
        <Stack
          flexDirection={isSmDown ? 'column-reverse' : 'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          gap={'20px'}
          sx={{
            ...(isSmDown && {
              width: '100%',
            }),
          }}
        >
          {downloadCsvBtn.show ? (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => onDownloadCsv?.()}
              sx={{
                ...(isSmDown && {
                  width: '100%',
                }),
              }}
              disabled={downloadCsvBtn.disabled}
            >
              {i18n.downloadCsv}
            </Button>
          ) : null}
          {updateCsvBtn.show ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => onGenerateCsv?.()}
              sx={{
                ...(isSmDown && {
                  width: '100%',
                }),
              }}
              disabled={updateCsvBtn.disabled}
            >
              {i18n.updateCsv}
            </Button>
          ) : null}
          {generateCsvBtn.show ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => onGenerateCsv?.()}
              sx={{
                ...(isSmDown && {
                  width: '100%',
                }),
              }}
              disabled={generateCsvBtn.disabled}
            >
              {i18n.generateCsv}
            </Button>
          ) : null}
        </Stack>
      </Stack>
      <Stack gap={'25px'}>
        {reports.map((report, idx) => (
          <WhiteCard key={idx} entity={report} isReport={true} />
        ))}
      </Stack>
    </>
  );
};
export default ReportList;
